export default __webpack_public_path__ + "static/media/reports-img.ac47f0b3.svg";